import InviteActions from '../actions/InviteActions'
import StorePrototype from '../../../shared_components/StorePrototype'

export default StorePrototype(InviteActions.Types.GOT_INVITE)
